/*
 * Junior Mini Company (Anforderung #92) — Auswahllisten, Stand und
 * Verlaufsereignisse. Spiegel von `services/miniCompanies/rules.js` im
 * Backend: Wer dort eine Liste ändert, ändert sie hier mit.
 *
 * Die Beschriftungen sind englische Schlüssel; die deutschen Texte stehen in
 * `i18n/miniCompanies.js`.
 */

export const JMC_STATUS = {
	DRAFT: 'DRAFT',
	SUBMITTED: 'SUBMITTED',
	ACTIVE: 'ACTIVE',
	REJECTED: 'REJECTED'
}

export const JMC_STATUS_LABELS = {
	DRAFT: 'JMC status draft',
	SUBMITTED: 'JMC status submitted',
	ACTIVE: 'JMC status active',
	REJECTED: 'JMC status rejected'
}

export const JMC_GRADE_LABELS = {
	GRADE_2: '2nd grade',
	GRADE_3: '3rd grade',
	GRADE_4: '4th grade',
	MIXED: 'Mixed-age class'
}

export const JMC_CLASS_ROLE_LABELS = {
	PRINCIPAL: 'Principal',
	CLASS_TEACHER: 'Class teacher',
	LEISURE_EDUCATOR: 'Leisure-time educator',
	MUSIC_TEACHER: 'Music teacher',
	TECH_DESIGN_TEACHER: 'Technology and design teacher'
}

export const JMC_GENDER_LABELS = {
	MALE: 'male',
	FEMALE: 'female'
}

export const JMC_LOG_LABELS = {
	JMC_CREATED: 'Junior Mini Company created',
	JMC_UPDATED: 'Details changed',
	JMC_PARTICIPANT_ADDED: 'Child added',
	JMC_PARTICIPANT_CHANGED: 'Child changed',
	JMC_PARTICIPANT_REMOVED: 'Child removed',
	JMC_CONSENT_UPLOADED: 'Consent forms uploaded',
	JMC_SUBMITTED: 'Submitted for approval',
	JMC_APPROVED: 'Approved by the state administration',
	JMC_REJECTED: 'Returned by the state administration',
	JMC_TEACHER_ADDED: 'Teacher added',
	JMC_TEACHER_INVITED: 'Teacher invited',
	JMC_TEACHER_JOINED: 'Invited teacher registered',
	JMC_TEACHER_REMOVED: 'Teacher removed',
	JMC_INVITATION_REVOKED: 'Invitation withdrawn',
	JMC_CERTIFICATES_GENERATED: 'Certificates generated'
}

/** Ändern nur im Entwurf oder nach einer Rückgabe — wie im Backend. */
export const isEditable = status => status === JMC_STATUS.DRAFT || status === JMC_STATUS.REJECTED

/** Auswahl für ein <select>: [{ value, label }] in der Reihenfolge der Liste. */
export const optionsOf = (labels, t) => Object.entries(labels).map(([value, label]) => ({ value, label: t(label) }))

/*
 * Download-Bereich: die Unterlagen von JAA, unverändert als PDF. Sie liegen
 * öffentlich unter /jmc/ (keine personenbezogenen Daten). Die
 * Einverständniserklärung nennt die Volkswirtschaftliche Gesellschaft Kärnten —
 * Annahme: JAA liefert Fassungen je Bundesland nach (JMC.md im Backend).
 */
export const JMC_DOWNLOADS = [
	{
		file: '/jmc/Einverstaendniserklaerung-Junior-Mini-Company.pdf',
		title: 'Consent form (parents)',
		text: 'One per child, signed by a parent or guardian. Afterwards scan all of them into one PDF and upload it below.'
	},
	{
		file: '/jmc/Anteilsschein-Junior-Mini-Company.pdf',
		title: 'Share certificate (5 euros)',
		text: 'For people who take a financial stake in the Junior Mini Company — for example parents or grandparents.'
	},
	{
		file: '/jmc/Fragebogen-Junior-Mini-Company.pdf',
		title: 'Questionnaire for the children',
		text: 'Questionnaire for pupils aged 8 to 10 at the end of the programme.'
	}
]

/** Wie im Backend: Schultyp „Volksschule", ohne Rücksicht auf Schreibweise und Rand. */
export const isVolksschule = schoolType =>
	String(schoolType || '')
		.trim()
		.toLowerCase() === 'volksschule'

/**
 * Lehrkraft an einer Volksschule: Sie arbeitet nur mit Junior Mini Companies
 * (Peter, 02.11.2026). Ihr Menü hat deshalb nur „Unternehmen" (dort stehen
 * ihre JMC) und „Mitteilungen"; Dashboard, Schüler:innen, Wirtschaftsexperten,
 * Konzepte, Kurse, Dokumente und Berichte gehören zu den Junior Companies.
 */
export const isJmcTeacher = (role, profile) => role === 'TEACHER' && isVolksschule(profile?.School?.type)
